import { styled } from 'baseui'

export const ButtonsColumn = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
})

export const ScriptContent = styled('div', ({ $theme }) => ({
  ...$theme.typography.ParagraphMedium,
  color: $theme.colors.contentPrimary,
  lineHeight: '1.5',
  ':first-child > :first-child': {
    marginTop: 0,
  },
}))

export const EmptyText = styled('p', ({ $theme }) => ({
  ...$theme.typography.ParagraphMedium,
  color: $theme.colors.contentSecondary,
  margin: 0,
}))
